var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartRecording2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 56,
    viewBox: "0 0 43 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5391 10.5C11.5391 4.97715 16.0162 0.5 21.5391 0.5C27.0618 0.5 31.5391 4.97715 31.5391 10.5V28C31.5391 33.5228 27.0618 38 21.5391 38C16.0162 38 11.5391 33.5228 11.5391 28V10.5Z",
    fill: "#53B7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16406 27.6094V27.9999C7.16406 31.8124 8.67856 35.4686 11.3744 38.1646C14.0702 40.8604 17.7266 42.3749 21.5391 42.3749C25.3516 42.3749 29.0078 40.8604 31.7038 38.1646C34.3996 35.4686 35.9141 31.8124 35.9141 27.9999V27.6094C35.9141 26.2286 37.0333 25.1094 38.4141 25.1094H39.6641C41.0448 25.1094 42.1641 26.2286 42.1641 27.6091V27.9999C42.1641 33.4699 39.9911 38.7161 36.1231 42.5839C32.9996 45.7076 28.9773 47.7256 24.6641 48.3869V52.9999C24.6641 54.3806 23.5448 55.4999 22.1641 55.4999H20.9141C19.5333 55.4999 18.4141 54.3806 18.4141 52.9999V48.3869C14.1008 47.7256 10.0785 45.7076 6.95499 42.5839C3.08704 38.7161 0.914062 33.4699 0.914062 27.9999V27.6094C0.914062 26.2286 2.03336 25.1094 3.41406 25.1094H4.66406C6.04476 25.1094 7.16406 26.2286 7.16406 27.6094Z",
    fill: "#53B7E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartRecording2);
export default __webpack_public_path__ + "static/media/start-recording (2).66d50a34565f0245ae3e5cc069500ef1.svg";
export { ForwardRef as ReactComponent };